import Button from "common/Buttons/Button";
import Text from "common/Typography/Text";
import { AdminSubGroup, LanguageNameSpaces } from "@shared/types";
import IntercomLink from "common/Text/IntercomLink.tsx";
import { showIntercom } from "utils/misc.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import Modal from "common/Modal/Modal.tsx";

interface BuyLicensesModalProps {
  open?: boolean;
  closeModal: () => void;
  adminSubGroupData?: AdminSubGroup;
}

const BuyLicensesModal = ({
  open,
  closeModal,
  adminSubGroupData,
}: BuyLicensesModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ADMIN);
  const allowLicense = adminSubGroupData?.configuration?.allow_license;

  const onClickSupport = () => {
    showIntercom();
    closeModal();
  };

  const footer = allowLicense ? (
    <Button key="support" type="primary" onClick={closeModal}>
      {t("licenses.buy.ok")}
    </Button>
  ) : (
    [
      <Button key="cancel" onClick={closeModal}>
        {t("licenses.buy.cancel")}
      </Button>,
      <Button key="support" type="primary" onClick={onClickSupport}>
        {t("licenses.buy.contactSupport")}
      </Button>,
    ]
  );

  return (
    <Modal
      onCancel={closeModal}
      open={open}
      title={t("licenses.buy.title")}
      footer={footer}
    >
      <Text>
        {allowLicense
          ? t("licenses.buy.availableViaTelegram")
          : t("licenses.buy.contactSupportMessage")}
        .
      </Text>
      {allowLicense && (
        <IntercomLink
          articleId="6397310"
          style={{ marginTop: 4, display: "block" }}
        />
      )}
    </Modal>
  );
};

export default BuyLicensesModal;
